import React from 'react';
import PropTypes from 'prop-types';

import Header from 'app/features/header/components/Header';
import Footer from 'app/features/footer/components/Footer';
import S from 'app/components/layout/Layout.styled';
import FlashMessage from 'app/features/flashMessage/FlashMessage';

const Layout = ({ Component }) => (
  <S.Layout>
    <Header />
    <FlashMessage />
    <Component />
    <Footer />
  </S.Layout>
);

Layout.propTypes = {
  Component: PropTypes.elementType.isRequired,
};

export default Layout;
